import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export default function LoadingScreen() {
  const [isLoading, setIsLoading] = useState(true);
  const [phase, setPhase] = useState(0);

  useEffect(() => {
    // Phase 1: letters appear
    const t1 = setTimeout(() => setPhase(1), 100);
    // Phase 2: heart pulse
    const t2 = setTimeout(() => setPhase(2), 1200);
    // Phase 3: fade out
    const t3 = setTimeout(() => setIsLoading(false), 2400);

    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
    };
  }, []);

  const letters = ['F', 'e', 'm', 'm', 'e', ' ', 'V', 'i', 'e'];

  return (
    <AnimatePresence>
      {isLoading && (
        <motion.div
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.8, ease: [0.25, 0.1, 0.25, 1] }}
          className="fixed inset-0 z-[999] flex flex-col items-center justify-center"
          style={{ background: '#FDF8F0' }}
        >
          {/* Logo text */}
          <div className="flex items-center gap-0.5">
            {letters.map((letter, i) => (
              <motion.span
                key={i}
                initial={{ opacity: 0, y: 20, rotateX: -40 }}
                animate={phase >= 1 ? { opacity: 1, y: 0, rotateX: 0 } : {}}
                transition={{
                  duration: 0.5,
                  delay: 0.08 * i,
                  ease: [0.25, 0.1, 0.25, 1],
                }}
                className="font-heading text-4xl md:text-5xl"
                style={{ color: '#8B7EC5' }}
              >
                {letter === ' ' ? '\u00A0' : letter}
              </motion.span>
            ))}
          </div>

          {/* Heart pulse */}
          <motion.div
            initial={{ opacity: 0, scale: 0 }}
            animate={phase >= 2 ? { opacity: 1, scale: 1 } : {}}
            transition={{ duration: 0.6, ease: [0.25, 0.1, 0.25, 1] }}
            className="mt-4"
          >
            <motion.div
              animate={phase >= 2 ? {
                scale: [1, 1.3, 1],
                opacity: [1, 0.7, 1],
              } : {}}
              transition={{
                repeat: Infinity,
                duration: 1.2,
                ease: 'easeInOut',
              }}
            >
              <svg
                width="28"
                height="28"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                  fill="#C4956A"
                />
              </svg>
            </motion.div>
          </motion.div>

          {/* Tagline */}
          <motion.p
            initial={{ opacity: 0 }}
            animate={phase >= 2 ? { opacity: 1 } : {}}
            transition={{ delay: 0.3, duration: 0.5 }}
            className="mt-6 text-[10px] tracking-[0.3em] uppercase font-label"
            style={{ color: '#AA9572' }}
          >
            Ginecologia Avançada
          </motion.p>

          {/* Progress bar */}
          <motion.div
            className="absolute bottom-[15%] left-1/2 -translate-x-1/2 w-32 h-[2px] rounded-full overflow-hidden"
            style={{ background: '#F0E4D0' }}
          >
            <motion.div
              initial={{ scaleX: 0 }}
              animate={{ scaleX: 1 }}
              transition={{ duration: 1.8, ease: [0.25, 0.1, 0.25, 1] }}
              className="h-full origin-left"
              style={{ background: '#8B7EC5' }}
            />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}